import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './style.css'

interface NavbarLink {
    label: string;
    link: string;
}
const navbarLinks: NavbarLink[] = [
    { label: 'Home', link: '/' },
    { label: 'About us', link: '/about' },
    { label: 'Contact us', link: '/contact' },
    { label: 'Privacy Policy', link: '/privacy-policy' },
]

const Navbar: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    return (
        <nav className='nav'>
            <div className='nav-container'>
                <div className='logo'>
                    <a href='/'>Blue Pigeon</a>
                </div>
                <div>
                    <div className='menu' onClick={toggleMenu}>
                        <img src="/icons/menu.svg" alt="" />
                    </div>
                    <ul className={`nav-links ${isMenuOpen?'':'hide'}`}>
                        {
                            navbarLinks.map((navbarLink, index) => {
                                return (
                                    <li key={index}>
                                        <NavLink to={navbarLink.link} className={({ isActive }) => (isActive ? 'active' : '')} onClick={()=>setIsMenuOpen(false)}>{navbarLink.label}</NavLink>
                                    </li>)
                            })
                        }
                    </ul>
                </div>
            </div>
        </nav>

    );
}

export default Navbar;
